module.exports = __webpack_public_path__ + "assets/img/advantage2.60306a66.png";